import { useMemo } from "react"
import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"
import { Caption } from ".."
import { getLastEditedDate } from "../../../utils"

import "./last-edit-date-caption.styles.scss"

export interface ILastEditDateCaptionProps {
  date?: Date
  customString?: string
}

export function LastEditDateCaption(props: ILastEditDateCaptionProps): ReactElement {
  const { date, customString } = props
  const { t } = useTranslation("myBosatlas")
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const lastEditString: string = useMemo<string>(() => {
    if (customString) return customString

    return getLastEditedDate(t, date?.toString())
  }, [date, customString])

  return <Caption className="last-edit-caption">{lastEditString}</Caption>
}
